import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import * as commonStyles from "../commonStyles/commonStyles.module.css";
import * as styles from "./SectionTitle.module.css";

type SectionTitleProps = Readonly<{
  title: string;
  subtitle?: string;
}>;

export const SectionTitle = ({ title, subtitle }: SectionTitleProps) => (
  <Row className={commonStyles.container}>
    <Column>
      <h3 className={styles.title}>{title}</h3>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </Column>
  </Row>
);
